import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import PageContainer from "../../layouts/PageContainer";
import Button from "@material-ui/core/Button";
import { LocationOn } from "@material-ui/icons";
import { TextField } from "@material-ui/core";
import { Grid } from "@mui/material";
import { helpers } from "../../helper/helper";
import icon from "../../assets/images/avatar-icon.png";
import PaginationControls from "./PaginationControls";
import PaginationInfo from "./PaginationInfo";
import { useLocation } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2";

const Posts = ({ data, count, FetchRemainingApprovalList, filterText }) => {
  // post top selection :
  const [loading, setLoading] = React.useState(false);
  const [search, setSearch] = React.useState("");
  const [totalCounts, setTotalCounts] = React.useState(null);
  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);
  const [list, setList] = React.useState([]);
  const history = useHistory();
  const location = useLocation();
  const [tag, setTag] = React.useState(location.state?.tag || "");
  const [modal, setModal] = React.useState(false);
  const [deletablePostId, setDeletablePostId] = useState("");


  useEffect(() => {
    setList(data);
    setTotalCounts(count);
  }, [data, count]);

  useEffect(() => {
    setPage(1);
  }, [filterText]);

  const handlePageChange = async (newPage) => {
    setPage(newPage);
    setLoading(true);
    await FetchRemainingApprovalList(filterText, search, newPage, limit);
    setLoading(false);
  };

  const handleSearch = async () => {
    setPage(1);
    setLoading(true);
    await FetchRemainingApprovalList(filterText, search, 1, limit);
    setLoading(false);
  };

  const handleAcceptPost = (id) => {
    Swal.fire({
      title: "Approve Post?",
      text: "Are you sure you want to approve this post?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Approve",
    }).then(async (result) => {
      console.log('result', result)
      if (result.value) {
        try {
          const url = `users/admin/pending/approve/update/${id}/v1`;

          const response = await helpers.apiCall("PUT", url, {
            type: filterText,
            status: "approved",
            reason: ""
          });

          if (response.status === 200) {
            Swal.fire("Approved!", "Post approved successfully.", "success");
            handleSearch(); // refresh list
          }
        } catch (error) {
          Swal.fire("Error!", "Something went wrong.", "error");
        }
      }
    });
  };

  const handleRejectPost = (id) => {
    Swal.fire({
      title: "Reject Post",
      input: "textarea",
      inputLabel: "Reason for rejection",
      inputPlaceholder: "Enter rejection reason...",
      inputAttributes: {
        "aria-label": "Type your reason here",
      },
      showCancelButton: true,
      confirmButtonText: "Reject",
      confirmButtonColor: "#d33",
      preConfirm: (reason) => {
        if (!reason) {
          Swal.showValidationMessage("Reason is required");
        }
        return reason;
      },
    }).then(async (result) => {
      console.log('result', result)
      if (result.value) {
        try {
          const url = `users/admin/pending/approve/update/${id}/v1`;

          const response = await helpers.apiCall("PUT", url, {
            reason: result.value,
            type: filterText,
            status: "rejected",
          });

          if (response.status === 200) {
            Swal.fire("Rejected!", "Post rejected successfully.", "success");
            handleSearch();
          }
        } catch (error) {
          Swal.fire("Error!", "Something went wrong.", "error");
        }
      }
    });
  };

  return (
    <>
      <PageContainer pageheading="Posts"></PageContainer>
      <div className="row">
        <div className="col-12">
          <div className="row m-3">
            <div className="col-6">
              {/* {tag ? (
                <h4 className="text-center mb-3">
                  <span style={{ color: "#F85476", fontSize: "22px" }}>
                    #{tag}
                  </span>{" "}
                  Posts
                </h4>
              ) : (
                <>
                  {hidePosts === "1" && <h4>Hide Posts</h4>}{" "}
                  {deletedPosts === "1" && <h4>Deleted Posts</h4>}
                </>
              )} */}
            </div>
            <div className="col-6">
              {/* {tag ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={(e) => handleClearTagButton()}
                >
                  Clear
                </Button>
              ) : (
                <>
                  {hidePosts === "1" || deletedPosts === "1" ? (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={(e) => handleClearBtnFilter()}
                    >
                      Back
                    </Button>
                  ) : (
                    <>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={(e) => handleShowDeletedPost()}
                      >
                        Deleted Posts
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        className="ml-3"
                        onClick={(e) => handleShowHidePost()}
                      >
                        Hide Posts
                      </Button>
                    </>
                  )}
                </>
              )} */}
            </div>
            <div className="col-6">
              <Grid item xs={12} sm={12} md={12}>
                <div className="">
                  <div className="input-group serch-sec">
                    <TextField
                      size="small"
                      variant="outlined"
                      type="search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      className="form-control rounded"
                      placeholder="Search Post Title, Created By user name and user Id"
                      aria-label="Search"
                      aria-describedby="search-addon"
                    />
                    &nbsp;
                    <Button
                      style={{ height: "38px" }}
                      variant="contained"
                      color="primary"
                      onClick={handleSearch}
                    >
                      Go
                    </Button>
                  </div>
                </div>
              </Grid>
            </div>
            <div className="col-6">
              <div className="row">
                <div className="col-md-6 d-flex">
                  {/* <p className="my-auto" style={{ fontWeight: "500" }}>1 to 10 of {totalCounts} items</p> */}
                  <PaginationInfo
                    page={page}
                    limit={limit}
                    totalCounts={totalCounts}
                  />
                </div>
                <PaginationControls
                  limit={limit}
                  onPageChange={handlePageChange}
                  page={page}
                  totalCounts={totalCounts}
                />
                {/* <div className="col-md-6 d-flex pagination-btns justify-content-end align-items-center">
                  <i className="mdi mdi-arrow-left"></i>
                  <span className="active">1</span>
                  <span>2</span>
                  <span>...</span>
                  <span>6</span>
                  <i className="mdi mdi-arrow-right"></i>
                </div> */}
              </div>
            </div>
          </div>
          {loading ? (
            <div
              style={{
                display: "flex",
                width: "100%",
                height: "60vh",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                className="spinner-border"
                style={{ color: "#F85476" }}
                role="status"
              >
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              <div className="row m-3">
                {list &&
                  list?.length > 0 &&
                  list?.map((post) => (
                    <div className="col-md-6 col-sm-12 mt-3" key={post?._id}>
                      <div className="post_card">
                        <div className="post_card_header">
                          <div>
                            <img
                              src={
                                post?.createdBy?.profilePic
                                  ? post.createdBy.profilePic
                                  : icon
                              }
                              alt=""
                              style={{ cursor: "pointer" }}
                              onClick={(e) =>
                                history.push(
                                  `/dashboard/users/${post?.createdBy?._id}`
                                )
                              }
                            />
                            <span className="ml-3">
                              {post?.createdBy?.name}
                            </span>
                            {post?.createdAt && (
                              <p style={{ fontSize: "12px", color: "#888" }}>
                                {moment(post.createdAt).format("MMM DD, YYYY [at] hh:mm A")}
                              </p>
                            )}
                          </div>
                          <div>
                            <>
                              <Button
                                variant="contained"
                                style={{ backgroundColor: "#4CAF50", color: "#fff" }}
                                className="mb-2 mr-1"
                                onClick={(e) => handleAcceptPost(post?._id)}
                              >
                                Accept
                              </Button>
                              <Button
                                variant="contained"
                                style={{ backgroundColor: "#f44336", color: "#fff" }}
                                className="mb-2"
                                onClick={(e) => handleRejectPost(post?._id)}
                              >
                                Reject
                              </Button>
                            </>
                          </div>
                        </div>
                        <div className="post_card_content">
                          <div className="post_media">

                            <p>{post?.title}</p>
                            {/* ["message", "image", "video", "location"] */}
                            {post?.type === "image" && (
                              <img
                                onClick={(e) =>
                                  window.open(post?.src, "__blank")
                                }
                                src={post?.src}
                                alt=""
                                style={{
                                  maxHeight: "280px",
                                  width: "auto",
                                  maxWidth: "100%",
                                  height: "auto",
                                  display: "block",
                                  margin: 0,
                                  objectFit: "contain",
                                  cursor: "pointer",
                                }}
                              />
                            )}
                            {post?.type === "audio" && (
                              <audio
                                controls
                                style={{
                                  width: "100%",
                                  maxWidth: "500px", // Adjust as needed
                                  margin: "0 auto",
                                  display: "block",
                                }}
                              >
                                <source src={post?.src} type="audio/mpeg" />
                                Your browser does not support the audio element.
                              </audio>
                            )}
                            {post?.type === "video" && (
                              <video
                                controls
                                style={{
                                  maxHeight: "280px",
                                  width: "auto",
                                  maxWidth: "100%",
                                  height: "auto",
                                  display: "block",
                                  margin: 0,
                                }}
                              >
                                <source src={post?.src} />
                              </video>
                            )}
                            {post?.type === "location" && (
                              <>
                                <p
                                  style={{ cursor: "pointer" }}
                                  onClick={(e) =>
                                    window.open(
                                      `https://www.google.com/maps?q=${post?.lat},${post?.long}`,
                                      "__blank"
                                    )
                                  }
                                >
                                  <LocationOn /> <span>{post?.address}</span>
                                </p>
                              </>
                            )}
                          </div>
                          <div className="post_hashtags">
                            {post?.tags &&
                              post?.tags?.length > 0 &&
                              post?.tags?.map((tag) => (
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={(e) => setTag(tag)}
                                >
                                  #{tag}
                                </span>
                              ))}
                          </div>
                          <div className="d-flex interaction-action">
                            <div className="d-flex flex-column align-items-center">
                              <span>{post?.views}</span>
                              <span
                                style={{ fontSize: "28px" }}
                                className="mdi mdi-arrow-right-drop-circle-outline"
                              ></span>
                              {/* <span>Views</span> */}
                            </div>
                            <div className="d-flex flex-column align-items-center">
                              <span>
                                {post?.totalZems ? post.totalZems : 0}
                              </span>
                              <span
                                style={{ fontSize: "28px" }}
                                className="mdi mdi-diamond-outline"
                              ></span>
                              {/* <span>Views</span> */}
                            </div>
                            <div
                              // onClick={() => {
                              //   setSelectedPostLikeData(post?.postLikes);
                              //   setLikeModal(!likeModal);
                              // }}
                              style={{ cursor: "pointer" }}
                              className="d-flex flex-column align-items-center"
                            >
                              <span>{post?.postLikes?.length}</span>
                              <span
                                style={{ fontSize: "28px" }}
                                className="mdi mdi-thumb-up-outline"
                              ></span>
                              {/* <span>Like</span> */}
                            </div>
                            <div
                              // onClick={() => {
                              //   setSelectedPostCommentData(post?.postComments);
                              //   setCommentModal(!commentModal);
                              // }}
                              style={{ cursor: "pointer" }}
                              className="d-flex flex-column align-items-center"
                            >
                              <span>{post?.postComments?.length}</span>
                              <span
                                style={{ fontSize: "28px" }}
                                className="mdi mdi-comment-text-outline"
                              ></span>
                              {/* <span>Comment</span> */}
                            </div>
                            <div className="d-flex flex-column align-items-center">
                              <span>{post?.share}</span>
                              <span
                                style={{ fontSize: "28px" }}
                                className="mdi mdi-share-outline"
                              ></span>
                              {/* <span>Share</span> */}
                            </div>
                            <div className="d-flex flex-column align-items-center">
                              <span>{post?.bookmarkCounts}</span>
                              <span
                                style={{ fontSize: "28px" }}
                                className="mdi mdi-bookmark-outline"
                              ></span>
                              {/* <span>Bookmark</span> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Posts;
